export interface ArticleSeoData {
  id: number | string
  title: string
  summary?: string
  cover_image?: string
  published_at?: string
  updated_at?: string
  source?: string
  category?: string
  tags?: string[]
}

export function generateNewsArticleLd(article: ArticleSeoData) {
  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: article.title,
    description: article.summary || '',
    image: article.cover_image || '',
    datePublished: article.published_at || '',
    dateModified: article.updated_at || article.published_at || '',
    author: {
      '@type': 'Person',
      name: article.source || '升学考试网',
    },
    publisher: {
      '@type': 'Organization',
      name: '升学考试网',
      logo: {
        '@type': 'ImageObject',
        url: 'https://sxks.go-gg.com/logo.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://sxks.go-gg.com/article/${article.id}`,
    },
    articleSection: article.category || '',
    keywords: article.tags || [],
    inLanguage: 'zh-CN',
  }
}
